/**
 * Plans sold via sales (e.g. Enterprise) must not show $0.
 * Prefer the explicit `contactSales` flag; fall back to non-free zero price
 * so cards stay correct even before the DB migration is applied.
 */
export function isContactSalesPlan(plan: {
  contactSales?: boolean | null;
  slug?: string | null;
  monthlyPrice?: string | number | null;
}): boolean {
  if (plan.contactSales) return true;
  const slug = String(plan.slug || '').toLowerCase();
  if (!slug || slug === 'free') return false;
  return parseFloat(String(plan.monthlyPrice ?? '0')) === 0;
}
